import type { RewardConditionProgressData } from '@/schemas/v2/user'

/** 1件の条件進捗データをテキストに変換する */
export function resolveConditionText(condition: RewardConditionProgressData): string {
  const { type, displayName, current, threshold } = condition
  const label = displayName ?? (type === 'STAMP_COUNT' ? 'スタンプ獲得状況' : type === 'POINT_SUM' ? 'ポイント' : null)
  return label ? `${label} ${current}/${threshold}` : `${current}/${threshold}`
}

/** 条件進捗データの配列をテキスト配列に変換する（CONDITION_GROUP は除外） */
export function resolveProgressTexts(conditions: RewardConditionProgressData[]): string[] {
  return conditions.filter((c) => c.type !== 'CONDITION_GROUP').map(resolveConditionText)
}
